var map = {
	"./de.json": [
		369,
		369
	],
	"./el.json": [
		3835,
		835
	],
	"./en.json": [
		389
	],
	"./es.json": [
		8302,
		302
	],
	"./fr.json": [
		5222,
		222
	],
	"./hr.json": [
		5276,
		276
	],
	"./hu.json": [
		6909,
		909
	],
	"./it.json": [
		4895,
		895
	],
	"./pl.json": [
		9026,
		26
	],
	"./pt_BR.json": [
		6611,
		611
	],
	"./ro.json": [
		7825,
		825
	],
	"./ru.json": [
		671,
		671
	],
	"./sq.json": [
		3362,
		362
	],
	"./sr.json": [
		8611,
		992
	],
	"./tr.json": [
		7304,
		304
	],
	"./uk.json": [
		8230,
		230
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5079;
module.exports = webpackAsyncContext;